<template>
  <div class="fts-history-notification-target">
    <fts-profile
      :user-list="users"
      :user-name="normalizedTarget"
      :profile-photo-size="14"
      fallback-name="(disabled user)"
      v-if="isEmail"
    />

    <fts-profile
      :user-list="users"
      :profile-id="normalizedTarget"
      :profile-photo-size="14"
      fallback-name="(disabled user)"
      v-else
    />
  </div>
</template>

<script>
import { emailValidator } from '../../commons/validator';
import FTSProfile from '../FTSProfile';

export default {
  components: {
    "fts-profile": FTSProfile
  },
  props: {
    target: String,
    users: Array,
  },
  computed: {
    /* #SS06011 the notification API returns targets verbatim, so a recipient saved with stray
       whitespace arrives as " user@domain.com". emailValidator is anchored, so the untrimmed
       value fails it and the target is resolved as a profile id instead — no match, and the
       recipient renders as "(disabled user)". Trim once, then both the branch and the profile
       lookup (which compares usernames exactly) see the real address. */
    normalizedTarget() {
      return typeof this.target === 'string' ? this.target.trim() : this.target;
    },
    isEmail() {
      return emailValidator(this.normalizedTarget);
    }
  }
};
</script>

<style lang="scss">
.fts-history-notification-target {
  min-width: 0;
}
</style>